import axios from "axios";
// import { throwIfNull, throwIfNullOrZeroOrNegative } from "../errors";

const endpoint = 'SuperSuppliers';

export default {

    //There  is not null safety exception 'cause it gets all data when it's null 
    // When values has something it means search by something 
    async getPaginated({ UserId, email }) {
        const uri = `${endpoint}/paginated`;
        const response = await axios.get(uri, {
            params: {
                userId: UserId,
                email: email
            }
        });
        return response.data;
    },
    async getById({ id }) {
        const uri = `${endpoint}/${id}`;
        const response = await axios.get(uri);
        return response.data;
    },
    async assignCorpUser({ request }) {
        const uri = 'suppliers/assignCorpUser';
        const response = await axios.post(uri, request);
        return response.data;
    }


};
